/**
 * Generated for Shopify by build-shopify.js — edit public/config.js instead.
 * Variant IDs, prices and the cart mode come from the section's Liquid: pick
 * the product in the theme editor and the real cart switches itself on.
 */

// 'local'   -> cart lives in localStorage, checkout posts a lead to this Node server (demand test)
// 'shopify' -> cart posts to /cart/add.js and checkout redirects to /checkout (real store)
window.CART_MODE = (window.NUMA_VARIANTS && Object.keys(window.NUMA_VARIANTS).length) ? 'shopify' : 'local';

window.STORE = {
  brand: 'NUMA SLEEP',
  currency: 'USD',
  symbol: '$',
  announcement: 'First production run · Reserve now, nothing charged today',
  // phones get the short one — the long line wraps to three cramped rows
  announcementShort: 'First run · Nothing charged today',

  product: {
    handle: 'numa-asmr-blanket',
    title: 'Numa ASMR Blanket',
    subtitle: 'Faux-fur ASMR throw',
    compareAt: 129,
    sizes: [
      { id: 'throw', label: 'Throw', dims: '50" × 60"', price: 89, weight: '3.2 lb', note: 'One person, sofa or bed' },
      { id: 'queen', label: 'Queen', dims: '90" × 90"', price: 149, weight: '6.4 lb', note: 'Covers a queen bed' },
      { id: 'king', label: 'King', dims: '108" × 90"', price: 189, weight: '8.1 lb', note: 'Two people, no tug-of-war' },
    ],
    colors: [
      { id: 'blush', label: 'Blush', hex: '#F0BCB2', status: 'in_stock' },
      { id: 'cream', label: 'Cream', hex: '#EFE4D6', status: 'in_stock' },
      { id: 'white', label: 'White', hex: '#F6F2EC', status: 'in_stock' },
    ],
    // sku -> Shopify numeric variant id. Fill these in when you move to Shopify.
    shopifyVariantId: window.NUMA_VARIANTS || {},
  },

  freeShippingThreshold: 75,

  // TikTok Ads → Assets → Events → Web Events. Paste the Pixel ID here and the
  // pixel loads itself; leave it empty and no third-party script is added.
  tiktokPixelId: '7673909263554609168',
};

/* Shopify is the source of truth for money. Without this the page could
   advertise $89 while the cart charges whatever the variant actually costs. */
if (window.NUMA_PRICES && Object.keys(window.NUMA_PRICES).length) {
  window.STORE.product.sizes.forEach((size) => {
    const key = Object.keys(window.NUMA_PRICES).find((k) => k.indexOf(size.id + '-') === 0);
    if (key != null) size.price = window.NUMA_PRICES[key];
  });
}
